var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocsLight({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.66683 1.89258V5.3347C9.66683 5.80141 9.66683 6.03476 9.75766 6.21302C9.83755 6.36982 9.96504 6.49731 10.1218 6.5772C10.3001 6.66803 10.5335 6.66803 11.0002 6.66803H14.4423M9.66683 14.168H4.66683M11.3335 10.8346H4.66683M14.6668 8.32482V14.3346C14.6668 15.7348 14.6668 16.4348 14.3943 16.9696C14.1547 17.44 13.7722 17.8225 13.3018 18.0622C12.767 18.3346 12.067 18.3346 10.6668 18.3346H5.3335C3.93336 18.3346 3.2333 18.3346 2.69852 18.0622C2.22811 17.8225 1.84566 17.44 1.60598 16.9696C1.3335 16.4348 1.3335 15.7348 1.3335 14.3346V5.66797C1.3335 4.26784 1.3335 3.56777 1.60598 3.03299C1.84566 2.56259 2.22811 2.18014 2.69852 1.94045C3.2333 1.66797 3.93336 1.66797 5.3335 1.66797H8.00998C8.62145 1.66797 8.92719 1.66797 9.21491 1.73704C9.47 1.79829 9.71386 1.8993 9.93754 2.03637C10.1898 2.19097 10.406 2.40716 10.8384 2.83954L13.4953 5.4964C13.9276 5.92877 14.1438 6.14496 14.2984 6.39726C14.4355 6.62094 14.5365 6.8648 14.5978 7.11989C14.6668 7.40761 14.6668 7.71335 14.6668 8.32482Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocsLight);
export default __webpack_public_path__ + "static/media/docs-light.009f8d7acde8009d13380183e33f1ed0.svg";
export { ForwardRef as ReactComponent };